// Ícones de traço simples (24×24, cor do texto), só os que o menu usa.
const CAMINHOS = {
  visao: 'M3 3h7v7H3zM14 3h7v7h-7zM14 14h7v7h-7zM3 14h7v7H3z',
  pagamentos: 'M2 6h20v12H2zM2 10h20M6 15h4',
  afiliados: 'M12 8a3 3 0 100-6 3 3 0 000 6zM5 21a3 3 0 100-6 3 3 0 000 6zM19 21a3 3 0 100-6 3 3 0 000 6zM12 8v4M12 12l-5.5 3.5M12 12l5.5 3.5',
  apostas: 'M3 17l5-6 4 4 8-9M14 6h6v6',
  cassino: 'M4 4h16v16H4zM8.5 8.5h.01M15.5 8.5h.01M12 12h.01M8.5 15.5h.01M15.5 15.5h.01',
  niveis: 'M3 20h18M5 20v-4h4v4M10 20v-8h4v8M15 20V7h4v13',
  risco: 'M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6zM12 8v5M12 16h.01',
  saques: 'M2 6h20v12H2zM12 9v6M9.5 12.5L12 15l2.5-2.5',
  jogadores: 'M16 19v-1a4 4 0 00-4-4H6a4 4 0 00-4 4v1M9 10a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM22 19v-1a4 4 0 00-3-3.9M16 3.1a3.5 3.5 0 010 6.8',
  dados: 'M4 6c0-1.7 3.6-3 8-3s8 1.3 8 3-3.6 3-8 3-8-1.3-8-3zM4 6v12c0 1.7 3.6 3 8 3s8-1.3 8-3V6M4 12c0 1.7 3.6 3 8 3s8-1.3 8-3',
  acessos: 'M5 11h14v10H5zM8 11V7a4 4 0 018 0v4M12 15v2',
  conteudo: 'M3 5h18v14H3zM3 15l5-5 4 4 3-3 6 6M15.5 9.5h.01',
  sair: 'M15 4h4v16h-4M10 8l-4 4 4 4M6 12h11',
  busca: 'M11 18a7 7 0 100-14 7 7 0 000 14zM21 21l-4.5-4.5',
  expandir: 'M4 4h16v16H4zM9 4v16M13 9l3 3-3 3',
  recolher: 'M4 4h16v16H4zM9 4v16M16 9l-3 3 3 3',
  filtro: 'M3 5h18M6 12h12M10 19h4',
  rede: 'M5 6a2 2 0 100-4 2 2 0 000 4zM19 6a2 2 0 100-4 2 2 0 000 4zM12 22a2 2 0 100-4 2 2 0 000 4zM5 6v3a3 3 0 003 3h8a3 3 0 003-3V6M12 12v6',
  aprovar: 'M9 11l3 3 8-8M20 12v7a2 2 0 01-2 2H6a2 2 0 01-2-2V5a2 2 0 012-2h9',
  cadastro: 'M15 19v-1a4 4 0 00-4-4H6a4 4 0 00-4 4v1M8.5 10a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM19 8v6M16 11h6',
} as const;

export type NomeIcone = keyof typeof CAMINHOS;

export function Icone({ nome, tamanho = 18 }: { nome: NomeIcone; tamanho?: number }) {
  return (
    <svg width={tamanho} height={tamanho} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.7} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d={CAMINHOS[nome]} />
    </svg>
  );
}
